export default __webpack_public_path__ + "static/media/4.1.532eae8e.jpg";